import { render, staticRenderFns } from "./DashboardHrPayroll.vue?vue&type=template&id=31b787b3&scoped=true"
import script from "./DashboardHrPayroll.vue?vue&type=script&lang=js"
export * from "./DashboardHrPayroll.vue?vue&type=script&lang=js"
import style0 from "./DashboardHrPayroll.vue?vue&type=style&index=0&id=31b787b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b787b3",
  null
  
)

export default component.exports